import {Injectable} from '@angular/core';
import {environment} from '@environments/environment';
import { HttpClient } from '@angular/common/http';
import {KatottgModel} from '@services/back-office/model/katottgModel';
import {Observable} from 'rxjs';
import {RoleModel} from '@services/back-office/model/roleModel';
import {KatottgSearchRequest} from '@services/back-office/model/katottgSearchRequest';
import {PaginationModel} from '@shared/models/pagination.model';
import {PageKatottgModel} from '@services/back-office/model/pageKatottgModel';
import {LocationPointModel} from '@services/back-office/model/locationPointModel';
import {KatottgRequest} from '@services/back-office/model/katottgRequest';

@Injectable({
    providedIn: 'root'
})
export class KatottgService {
    private baseUrl = environment.baseUrl;

    constructor(
        private http: HttpClient,
    ) {
    }

    /** Get Katottg */
    getKatottg(request: KatottgSearchRequest, pagination?: PaginationModel): Observable<PageKatottgModel> {
        const serializedRequest = {
            ...request,
            categories: request.categories ? Array.from(request.categories) : undefined
        };
        const url = `${this.baseUrl}/back-office/v1/classifier/katottg/list?page=${pagination ? pagination.number : ''}&size=${pagination ? pagination.size : '50'}`;
        return this.http.post<PageKatottgModel>(url, serializedRequest);
    }

    /** Set Katottg location */
    setKatottgLocation(katottgId: string, request: LocationPointModel[]): Observable<KatottgModel> {
        const url = `${this.baseUrl}/back-office/v1/classifier/katottg/location/${katottgId}`;
        return this.http.put<RoleModel>(url, request);
    }

    /** Add Katottg city region */
    addKatottgCityRegion(request: KatottgRequest): Observable<KatottgModel> {
        const url = `${this.baseUrl}/back-office/v1/classifier/katottg`;
        return this.http.post<RoleModel>(url, request);
    }

    /** Edit Katottg city region */
    editKatottgCityRegion(katottgId: string, request: KatottgRequest): Observable<KatottgModel> {
        const url = `${this.baseUrl}/back-office/v1/classifier/katottg/${katottgId}`;
        return this.http.put<RoleModel>(url, request);
    }

    /** Delete Katottg city region */
    deleteKatottgCityRegion(katottgId: string): Observable<KatottgModel> {
        const url = `${this.baseUrl}/back-office/v1/classifier/katottg/${katottgId}`;
        return this.http.delete<RoleModel>(url);
    }
}
